// @flow

// Converts a programming language used in code fences to a human readable title.
export const getLanguageTitle = (lang: string) => {
  switch (lang.toLowerCase()) {
    case 'curl':
    case 'bash':
      return 'curl';
    case 'ruby':
      return 'Ruby';
    case 'js':
    case 'javascript':
      return 'JavaScript';
    case 'javascript_esnext':
      return 'Javascript (ESNext)';
    case 'node':
      return 'Node';
    case 'python':
      return 'Python';
    case 'php':
      return 'PHP';
    case 'java':
      return 'Java';
    case 'go':
      return 'Go';
    case 'html':
      return 'HTML';
    case 'dotnet':
    case 'csharp':
      return '.NET';
    case 'objc':
      return 'Objective C';
    default:
      return lang;
  }
};
